import { useState } from "react";
import {
  Grid,
  TextField,
  DataGrid,
  Autocomplete,
  Button,
  FormControl,
} from "../../../../../components";
import {
  EnderecoService,
  notification,
  MdfeService,
  MdfeMunicipiosCarregamentoService,
  MdfePercursosService,
} from "../../../../../services";
import { responseErros } from "../../../../../utils";
import shortid from "shortid";

const enderecoService = new EnderecoService();
const mdfeService = new MdfeService();
const mdfeMunicipiosCarregamentoService =
  new MdfeMunicipiosCarregamentoService();
const mdfePercursosService = new MdfePercursosService();

export default function TabItinerarioTransporte({
  carregamentos,
  setCarregamentos,
  estados,
  id,
  setLoading,
  status,
  percursos,
  setPercursos,
}) {
  const [cidades, setCidades] = useState([]);
  const [estadoCarregamento, setEstadoCarregamento] = useState(null);
  const [cidade, setCidade] = useState(null);
  const [erroCidade, setErroCidade] = useState(false);
  const [estadoPercurso, setEstadoPercurso] = useState(null);
  const [erroEstado, setErroEstado] = useState(false);
  const carregamentoColunas = [
    {
      field: "nome",
      headerName: "Nome",
      flex: 300,
    },
    {
      field: "codigo",
      headerName: "Codigo",
      flex: 200,
    },
    {
      field: "uf",
      headerName: "UF",
      flex: 100,
      filtrar: true,
    },
  ];
  const percursoColunas = [
    {
      field: "uf",
      headerName: "UF",
      flex: 200,
    },
  ];

  const changeCidadesByEstadoId = async (id) => {
    if (id) {
      enderecoService.getCidades(id).then((response) => {
        if (!response.isAxiosError) {
          if (!response.data) {
            notification.erroValidacao("Preencha um estado");
          } else {
            setCidades(response.data);
          }
        } else {
          responseErros(response);
        }
      });
    }
  };

  const onChangeEstadoCarregamento = async (newValue) => {
    setEstadoCarregamento(newValue || null);
    setCidade(null);
    if (newValue?.id) {
      changeCidadesByEstadoId(newValue.id);
    }
  };

  const onChangeEstadoPercurso = async (newValue) => {
    setEstadoPercurso(newValue || null);
  };

  const onChangeCidade = (newValue) => {
    setCidade(newValue || null);
  };

  const onClickAdicionarCarregamento = () => {
    if (!cidade) {
      setErroCidade(true);
      return notification.erroValidacao("Cidade");
    }
    const carregamentoAdicao = {
      id: shortid.generate(),
      cidadeId: cidade.id,
      nome: cidade.nome,
      codigo: cidade.codigoIbge,
      uf: cidade.estado.sigla,
    };
    if (id) {
      cadastrarCarregamento(carregamentoAdicao);
    } else {
      setCarregamentos([...carregamentos, carregamentoAdicao]);
    }
    setErroCidade(false);
    setEstadoCarregamento(null);
    setCidade(null);
    setCidades([]);
  };

  async function cadastrarCarregamento(carregamentoAdicao) {
    setLoading(true);
    const response = await mdfeService.cadastrarMunicipioCarregamento(
      id,
      carregamentoAdicao
    );
    if (!response.isAxiosError) {
      await buscarCarregamento();
      setLoading(false);
      notification.cadastroSucesso();
    } else {
      setLoading(false);
      responseErros(response);
    }
  }

  async function buscarCarregamento() {
    const filter = {
      fatMdfeId: id,
      nonPaginated: true,
    };
    const response = await mdfeMunicipiosCarregamentoService.getAll(filter);
    if (!response.isAxiosError) {
      setCarregamentos(response.data);
    } else {
      responseErros(response);
    }
  }

  async function deletarCarregamento(idCarregamento) {
    setLoading(true);
    const response = await mdfeMunicipiosCarregamentoService.deletar(
      idCarregamento
    );
    if (!response.isAxiosError) {
      await buscarCarregamento();
      setLoading(false);
      notification.deletadoSucesso();
    } else {
      setLoading(false);
      responseErros(response);
    }
  }

  const onclickDeletarCarregamento = (idCarregamento) => {
    if (id) {
      deletarCarregamento(idCarregamento);
    } else {
      setCarregamentos(
        carregamentos.filter(
          (carregamento) => carregamento.id != idCarregamento
        )
      );
    }
  };

  async function deletarPercurso(idPercurso) {
    setLoading(true);
    const response = await mdfePercursosService.deletar(idPercurso);
    if (!response.isAxiosError) {
      await buscarPercursos();
      setLoading(false);
      notification.deletadoSucesso();
    } else {
      setLoading(false);
      responseErros(response);
    }
  }

  const onclickDeletarPercurso = (idPercurso) => {
    if (id) {
      deletarPercurso(idPercurso);
    } else {
      setPercursos(percursos.filter((percurso) => percurso.id != idPercurso));
    }
  };

  async function buscarPercursos() {
    const filter = {
      fatMdfeId: id,
      nonPaginated: true,
    };
    const response = await mdfePercursosService.getAll(filter);
    if (!response.isAxiosError) {
      setPercursos(response.data);
    } else {
      responseErros(response);
    }
  }

  async function cadastrarPercurso(percursoAdicao) {
    setLoading(true);
    const response = await mdfeService.cadastrarPercurso(id, percursoAdicao);
    if (!response.isAxiosError) {
      await buscarPercursos();
      setLoading(false);
      notification.cadastroSucesso();
    } else {
      setLoading(false);
      responseErros(response);
    }
  }

  const onClickAdicionarPercurso = () => {
    if (!estadoPercurso) {
      setErroEstado(true);
      return notification.erroValidacao("Estado");
    }
    const percursoAdicao = {
      id: shortid.generate(),
      estadoId: estadoPercurso.id,
      uf: estadoPercurso.sigla,
    };
    if (id) {
      cadastrarPercurso(percursoAdicao);
    } else {
      setPercursos([...percursos, percursoAdicao]);
    }
    setErroEstado(false);
    setEstadoPercurso(null);
  };

  return (
    <Grid container>
      <Grid container xs={6} spacing={2} className="mt-1">
        <Grid item xs={5}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              required
              id="estado"
              name="estado"
              options={estados}
              noOptionsText="Sem opções"
              autoHighlight
              getOptionLabel={(option) =>
                option.sigla && option.nome
                  ? `${option.sigla} - ${option.nome}`
                  : ""
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Estado Carregamento"
                  variant="outlined"
                />
              )}
              onChange={(event, newValue) =>
                onChangeEstadoCarregamento(newValue)
              }
              value={estadoCarregamento}
            />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              required
              id="cidade"
              name="cidade"
              options={cidades}
              noOptionsText="Sem opções"
              autoHighlight
              disabled={!estadoCarregamento ? true : false}
              getOptionLabel={(option) => (option.nome ? option.nome : "")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Cidade Carregamento"
                  variant="outlined"
                  error={erroCidade}
                />
              )}
              onChange={(event, newValue) => {
                onChangeCidade(newValue);
              }}
              value={cidade}
            />
          </FormControl>
        </Grid>
        <Grid item xs={1}>
          <Button
            id="buttonAdicionar"
            variant="contained"
            color="success"
            size="small"
            className="mt-4"
            disabled={status != "PENDENTE" ? true : false}
            sx={{
              height: "35px",
              borderRadius: "50%",
              minWidth: "15px",
              boxShadow: "none",
            }}
            onClick={onClickAdicionarCarregamento}
          >
            <i
              className="ph-bold ph-plus"
              style={{ color: "#fff", fontSize: 15 }}
            ></i>
          </Button>
        </Grid>
        <Grid item xs={12}>
          <DataGrid
            style={{ zIndex: 1 }}
            rows={carregamentos}
            columns={carregamentoColunas}
            rowCount={carregamentos.length}
            onClickDelete={onclickDeletarCarregamento}
            deleteShow={status != "PENDENTE" ? false : true}
          />
        </Grid>
      </Grid>
      <Grid
        container
        xs={1}
        fullWidth
        className="d-flex justify-content-center"
      >
        <hr className="vr" />
      </Grid>
      <Grid container xs={5} spacing={2} className="mt-2">
        <Grid item xs={9}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              required
              id="estado"
              name="estado"
              options={estados}
              noOptionsText="Sem opções"
              autoHighlight
              getOptionLabel={(option) =>
                option.sigla && option.nome
                  ? `${option.sigla} - ${option.nome}`
                  : ""
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Estado Percurso"
                  variant="outlined"
                  error={erroEstado}
                />
              )}
              onChange={(event, newValue) => onChangeEstadoPercurso(newValue)}
              value={estadoPercurso}
            />
          </FormControl>
        </Grid>
        <Grid item xs={2}>
          <Button
            id="buttonAdicionar"
            variant="contained"
            color="success"
            size="small"
            className="mt-4"
            disabled={status != "PENDENTE" ? true : false}
            sx={{
              height: "35px",
              borderRadius: "50%",
              minWidth: "15px",
              boxShadow: "none",
            }}
            onClick={onClickAdicionarPercurso}
          >
            <i
              className="ph-bold ph-plus"
              style={{ color: "#fff", fontSize: 15 }}
            ></i>
          </Button>
        </Grid>
        <Grid item xs={12}>
          <DataGrid
            style={{ zIndex: 1 }}
            rows={percursos}
            columns={percursoColunas}
            rowCount={percursos.length}
            onClickDelete={onclickDeletarPercurso}
            deleteShow={status != "PENDENTE" ? false : true}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
